import React from "react";
import { motion } from "framer-motion";
import { BrainCircuit, Blocks, ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import HeroSystemPreview from "@/components/landing/HeroSystemPreview";

const pillars = [
  {
    icon: BrainCircuit,
    title: "AI-Native",
    description: "Built around intelligence, not apps.",
  },
  {
    icon: Blocks,
    title: "Composable",
    description: "Everything is modular. Everything connects.",
  },
  {
    icon: ShieldCheck,
    title: "Sovereign",
    description: "Runs local. Own your compute. Own your data.",
  },
];

export default function WhyMapleOS() {
  return (
    <section id="a-living-system" className="scroll-mt-24 px-4 py-14 sm:px-6 sm:py-20 md:py-28">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.55 }}
          className="mx-auto mb-8 max-w-3xl text-center sm:mb-12"
        >
          <h2 className="mt-4 text-2xl font-semibold tracking-[-0.05em] text-white sm:mt-5 sm:text-3xl md:text-5xl">
            Trust should be built in.
          </h2>
          <p className="mt-4 px-2 text-sm leading-7 text-white/60 sm:px-0 sm:text-base md:text-lg">
            MapleOS is for people who are done handing over their work, files, and attention to platforms that no longer respect control.
          </p>
        </motion.div>

        <div className="hidden sm:block">
          <HeroSystemPreview />
        </div>
      </div>
    </section>
  );
}
